import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  PatternDialogComponent,
  PatternDialogData,
} from '../components/pattern-dialog/pattern-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ModalConfirmService {
  constructor(
    private dialog: MatDialog,
    private sheet: MatBottomSheet,
    private bp: BreakpointObserver
  ) {}

  open(data: PatternDialogData): Observable<boolean | undefined> {
    const isHandset = this.bp.isMatched(Breakpoints.Handset);

    const ref:
      | MatDialogRef<PatternDialogComponent, boolean>
      | MatBottomSheetRef<PatternDialogComponent, boolean> = isHandset
      ? this.sheet.open(PatternDialogComponent, { data })
      : this.dialog.open(PatternDialogComponent, { data });

    return 'afterClosed' in ref ? ref.afterClosed() : ref.afterDismissed();
  }
}
